import templateUrl from './terms-and-condition.html';

export const termsAndConditionComponent = {
    bindings: {
        details: '<'
    },

    templateUrl,

    controller: class TermsAndConditionComponent {
        constructor($state, toastr, CompareObjectService, ModalService, TermsAndConditionService) {
			'ngInject';

			this.$state = $state;
			this.toastr = toastr;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
			this.termsAndConditionService = TermsAndConditionService;
		}

        $onInit() {
			this.details = this.termsAndConditionService.getTermsAndConditionObject(this.details);
			this.details.pageTitle = "Edit Terms & Conditions";
			this.savedData = angular.copy(this.details.menuContentDetails);
		}

        onCancel() {
			const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, false);
			
			if (isUpdated) {
				this.modalService.open({
					details: {
						bodyMessage: 'Changes done will be reverted. Continue?'
					},
					buttons: [{
						name: 'No'
					}, {
						name: 'Yes',
						isPrimary: true,
						action: _onSubmit.bind(this)
					}]
				});

				function _onSubmit() {
					this._redirectToParentState('home-banner');
				}
			} else {
				this._redirectToParentState('home-banner');
			}
		}

		onSubmit() {
			this.disableButtons = true;
			const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, true);

			if (isUpdated) {
				this.termsAndConditionService.editTermsAndCondition(this.details.menuContentDetails)
                    .then(_ => {
                        this.toastr.success('Terms And Conditions is updated successfully');
				        this.disableButtons = false;
                    })
                    .catch(err => {
                        this.toastr.error(err);
                        this.disableButtons = false;
                    });
			}
			else {
				this.toastr.success('Nothing to update');
				this.disableButtons = false;
			}
		}

		_redirectToParentState(slug) {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: slug
			});
		}
    }
};


// WEBPACK FOOTER //
// ./src/app/components/terms-and-condition/terms-and-condition.component.js